<template>
  <v-card class="tab-card mutual-fund-box" v-if="items.length != 0">
    <v-tabs v-model="tab">
      <v-tab
        v-for="item in items"
        :key="item.scheme_type_id"
        class="tabs-box"
        :href="'#tab-' + item.scheme_type_id"
      >
        {{ item.scheme_type }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item
        v-for="item in items"
        :key="'tab-' + item.scheme_type_id"
        :value="'tab-' + item.scheme_type_id"
      >
        <template>
          <v-row>
            <v-col>
              <v-container pb-4 grid-list-xl>
                <v-layout row wrap class="user-detailboxmain">
                  <v-flex class="user-detailbox">
                    <v-list-item
                      v-for="(savingAccounts,  index) in item.scheme_detail"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <h3>{{ savingAccounts.name }}</h3>
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-for="(contents) in savingAccounts.content"
                          :key="savingAccounts.id"
                        >
                          <div class="account-detailbox">
                            <div class="bank-name">
                              <span>Scheme Name</span>
                              <h5>{{ contents.scheme_name }}</h5>
                            </div>
                            <div class="amount-box">
                              <v-col class="memberbox-editbox">
                                <v-menu bottom left offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      fab
                                      color="#F19700"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="showHide(contents['form_id'])"
                                      v-if="allow_user_activity == 'yes'"
                                    >
                                      <v-img
                                        max-height="20"
                                        max-width="20"
                                        :src="three_dots"
                                        :lazy-src="three_dots"
                                      ></v-img>
                                    </v-btn>
                                  </template>
                                  <v-list
                                    v-if="hideShowId == contents['form_id']"
                                  >
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            editMutualFunds(
                                              contents['form_id'],
                                              contents['form_type'],
                                              item.scheme_type_id
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="20"
                                            max-width="20"
                                            :src="edit_pic"
                                            :lazy-src="edit_pic"
                                          ></v-img>
                                          Edit
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="
                                            deleteMutualFunds(
                                              contents['form_id']
                                            )
                                          "
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="delete_pic"
                                            :lazy-src="delete_pic"
                                          >
                                          </v-img
                                          >Delete
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-title>
                                        <v-btn
                                          @click="updateMutualFunds(contents)"
                                        >
                                          <v-img
                                            max-height="23"
                                            max-width="19"
                                            :src="update_pic"
                                            :lazy-src="update_pic"
                                          >
                                          </v-img
                                          >Update units
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                              <span>
                                NAV on
                                {{
                                  contents.nav_start_date | moment("DD MMM, Y")
                                }}
                              </span>
                              <p><span> &#8377;</span> {{ contents.nav }}</p>
                            </div>
                          </div>
                          <div class="other-detail">
                            <div class="no-box">
                              <span>Folio Number</span>
                              <h4>{{ contents.folio_no }}</h4>
                            </div>
                            <div class="amount-box">
                              <span
                                >Investment on
                                {{ currentDate | moment("DD MMM, Y") }}</span
                              >
                              <p>
                                <span> &#8377;</span>
                                {{ contents.total_investment }}
                              </p>
                            </div>
                          </div>
                          <div class="unit-detail">
                            <div class="no-box">
                              <span>Units</span>
                              <h4 if="contents.balance_units">
                                {{ contents.balance_units }}
                              </h4>
                              <h4 if="contents.balance_unit">
                                {{ contents.balance_unit }}
                              </h4>
                            </div>
                            <div class="amount-box">
                              <span
                                >Valuation on
                                {{ currentDate | moment("DD MMM, Y") }}</span
                              >
                              <p>
                                <span>&#8377;</span>
                                {{ contents.current_value }}
                              </p>
                            </div>
                          </div>
                          <div class="unit-detail">
                            <div class="no-box" v-if="contents.sip_frequency">
                              <span>SIP Frequency</span>
                              <h4>{{ contents.sip_frequency }}</h4>
                            </div>
                            <div
                              class="amount-box"
                              v-if="contents.monthly_slip_amount"
                            >
                              <span>SIP Installment </span>
                              <p>
                                <span>&#8377;</span>
                                {{ contents.monthly_slip_amount }}
                              </p>
                            </div>
                          </div>

                          <div class="maturity-Datebox">
                            <div class="bank-name">
                              <label>Investment Goal</label>
                              <v-select
                                name="cap"
                                :v-model="cap"
                                :items="capList"
                                item-value="type"
                                item-text="name"
                                @change="updatFormCap(contents['form_id'], $event)"
                                bg-color="red"
                                placeholder="Please select your options"
                                class="inline select-box"
                                :value="contents['saving_type']"
                                outlined
                                style="width:400px; border-width:2px;"
                              ></v-select> 
                            </div>
                            <div class="amount-box">
                              

                              <span>Nominee/s</span>
                              <p v-if="contents.nominee.length != 0">
                                <span v-for="(items, index) in contents.nominee"
                                  >{{ items
                                  }}<span
                                    v-if="contents.nominee.length > index + 1"
                                    >,
                                  </span></span
                                >
                              </p>
                              <p v-else>N/A</p>
                            </div>
                          </div>
                          <div
                            class="total-amount-box"
                            v-if="contents.length != 0 && item.scheme_detail.length == (index + 1)"
                          >
                            <h4>Total {{ item.scheme_type }} Balance</h4>
                            <div class="total-amount">
                              <span
                                >As on
                                {{ currentDate | moment("DD MMM, Y") }}</span
                              >
                              <p>
                                <span> &#8377;</span>
                                {{ item.tot_scheme_balance.toLocaleString() }}
                              </p>
                            </div>
                          </div>
                         
                          
                        </v-list-item-subtitle>

                      </v-list-item-content>
                    </v-list-item>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-col>
          </v-row>
        </template>
      </v-tab-item>
    </v-tabs-items>
    <modal
      class="common-modal-box small-modal-box my-custom-modal"
      name="update-unit"
    >
      <span class="close">
        <v-img
          width="20"
          height="20"
          @click="close"
          style="float: right"
          :src="require('@/assets/images/cross.png')"
        >
        </v-img>
      </span>
      <v-form ref="update" lazy-validation>
        <v-text-field
          v-model="update_unit"
          value=""
          :rules="[(v) => !!v || 'Field is required']"
          placeholder="Enter Current Units"
          class="balance-field"
        >
        </v-text-field>
        <a href="javascript:void(0)" v-on:click="getAccountHelpDetail()"
          >GET HELP ?</a
        >
        <v-btn class="update-btn" @click="updateFundsUnit">
          Update Units
        </v-btn>
      </v-form>
    </modal>
     <v-dialog v-model="account_help_dialog" persistent  width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"  v-if="this.sms_array != ''" style="word-break: break-word;">
            You can get the number of units held in your folio from your account statement by sending an SMS as specified below.
          </v-card-title>
          <v-card-title class="text-h5 grey lighten-2" v-else>
            You can get the number of units held in your fund from your account statement by clicking on the link below.
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                       
              </v-col>  
            </v-row> 
            <div class="custom-notiBox">
              <v-layout class="notificationbox">
                <div class="noti-box inner-notificationbox">
                  <v-card class="imagebox" v-if="this.sms_array != ''">
                    <div class="noti-innerBox" >
                      <h4 style="padding-top:10px !important">Send SMS ({{this.sms_array.sms_str}}) to {{this.sms_array.sms_no}}</h4>
                      <v-img max-height="25" max-width="25" :src="sms_icon" :lazy-src="sms_icon"></v-img>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">The password length must be 6 characters, and must contain atleast 2 numbers and 2 alphabets.</h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">Note: You will receive the account statment in your email registered against the foilo.</h4>
                    </div>
                  </v-card>
                  <v-card class="imagebox" v-else>
                    <div class="noti-innerBox">
                      <h4 styler="padding-top:10px !important">
                        You have to enter your registered Email ID and enter a self-extracted pasword. Check your registered Email ID to view the statement. Use password to open the statement.
                      </h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">You can obtain your Consolidated Account Statement of your holdings across Kfintech serviced mutual funds by clicking on the link below.</h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important"><a href="https://mfs.kfintech.com/investor/General/AccountStatement" title="Click here to get account statement" target="blank">Click here to get Account Statement</a></h4>
                    </div>
                  </v-card> 
                </div>
              </v-layout>
            </div>   
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="account_help_dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-card>
  <v-card class="tab-card mutual-fund-box" v-else>
    <template>
      <v-row>
        <v-col>
            Record Not Found!
        </v-col>
      </v-row>
    </template>          
  </v-card>  
</template>

<script>
import {
  POST_API,
  GET_API,
  GET_MUTUAL_FUND_DATA,
  DELETE_MUTUALFUND_DATA,
} from "../../store/actions.type";
import { isEmpty } from "lodash";
import { Auth } from "aws-amplify";
import axios from "axios";
export default {
  data() {
    return {
      tab: 0,
      //items: [],
      three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
      currentDate: new Date().setDate(new Date().getDate()),
      edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
      delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
      update_pic: process.env.VUE_APP_ROOT_ICONS_URL + "update.png",
      sms_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'sms_icon.png',
      whatsapp_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'whatsapp_icon.png',
      phone_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'phone_icon.png',
      hideShow: false,
      hideShowId: "",
      folio_no: "",
      mfc_id: "",
      update_unit: "",
      account_help_dialog: false,
      missed_call_no_array: "",
      sms_array: "",
      cancelChangeArray: [],
      allow_user_activity: localStorage.getItem("allow_user_activity"),
      capList:[{"type":"Saving for Retirement","name":"Saving for Retirement"},{"type":"Saving to fund Children's Education","name":"Saving to fund Children's Education"},{"type":"Saving for a vacation","name":"Saving for a vacation"},{"type":"Buying a home","name":"Buying a home"},{"type":"Starting a business","name":"Starting a business"},{"type":"Building an emergency fund","name":"Building an emergency fund"},{"type":"Paying of debt","name":"Paying of debt"},{"type":"Pre payment of Home Loan","name":"Pre payment of Home Loan"}],

      cap:''
    };
  },
  created() {
    Fire.$on("loadData", () => {
      this.getMutualFundData();
    });
  },
  mounted() {
    if (this.isDataEmpty) this.getMutualFundData();

    if (this.$route.params.from == "edit") {
      this.tab = this.$route.params.tab;
    }
    if (this.$route.params.from == "add") {
      setTimeout(() => {
        this.tab = this.$route.params.tab;
      }, 2000);
    }
  },

  computed: {
    isDataEmpty: function () {
      return isEmpty(this.$store.getters.allMutualFundData);
    },
    items: function () {
      return !this.isDataEmpty
        ? this.$store.getters.allMutualFundData.data
        : [];
    },
    // tabNavigation: function () {
    //   return !isEmpty(this.$route.params.tab) ? this.$route.params.tab : null;
    // }
  },
  methods: {
    close() {
      this.$modal.hide("update-unit");
    },
    showHide(id) {
      this.hideShowId = id;
      this.hideShow = this.hideShow ? false : true;
    },
    showHideAgain(id) {
      this.cancelChangeArray.push(id);
      if (
        this.cancelChangeArray.length > 1 &&
        this.cancelChangeArray[this.cancelChangeArray.length - 2] != id
      ) {
        this.hideShow = true;
      }
    },
    updateMutualFunds(savingData) {
      console.log("ihgvv", savingData);
      this.$modal.show("update-unit");
      this.folio_no = savingData.folio_no;
      this.mfc_id = savingData.mfc_id;
      this.form_id = savingData.form_id;
    },
    updateFundsUnit() {
      // if (this.$refs.update.validate()) {
     
     
      let formdata = new FormData();
      formdata.append(
        "aws_cognito_id",
        atob(localStorage.getItem("cognito_idp"))
      );
      formdata.append("form_id", this.form_id);
      formdata.append("unit", this.update_unit);
      formdata.append("module_type", "mutual_fund");
     
      axios
        .post(process.env.VUE_APP_ROOT_API + "update-units", formdata)
        .then((res) => {
          this.$modal.hide("update-unit");
          swal.fire({
            title: "Unit Updated Successfully",
            icon: "success",
          });
          this.getMutualFundData();
          // this.$loading(false)
        })
        .catch(() => {});
      // }
    },
    editMutualFunds(editId, form_type, tabId) {
      return form_type == 31
        ? this.$router
            .push({
              path:
                "/edit-lumpsum-investment/" + btoa(editId) + "/" + btoa(tabId),
            })
            .catch(() => {})
        : this.$router
            .push({
              path:
                "/edit-systematic-investment-plan/" +
                btoa(editId) +
                "/" +
                btoa(tabId),
            })
            .catch(() => {});
    },
    deleteMutualFunds(id) {
      swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem("cognito_idp"));
            let user_name = this.$store.getters.getUserDetails.user_name;

            this.$store
              .dispatch(DELETE_MUTUALFUND_DATA, {
                data: {
                  aws_cognito_id: cognito_idp,
                  form_id: id,
                },
                api: "delete-form",
              })
              .then(() => {
                Fire.$emit("mutualFundGraphData");
                this.getMutualFundData();
                Toast.fire({
                  icon: "success",
                  title: "Data deleted successfully.",
                });
              });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    getMutualFundData() {
      this.$loading(true);
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      selected_value = selected_value ? selected_value : "";
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      this.$store
        .dispatch(GET_MUTUAL_FUND_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            member_id: selected_value,
            user_name: user_name,
            mutual_filter: "scheme",
          },
          api: "get-user-mutual-fund-form-mobile-detail",
        })
        .then(() => {
          Fire.$emit("mutualFundGraphData");
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
    },
    getAccountHelpDetail() {
      console.log("dfyuiohgvhjk");
      let formdata = new FormData();
      formdata.append(
        "aws_cognito_id",
        atob(localStorage.getItem("cognito_idp"))
      );
      formdata.append("folio_no", this.folio_no);
      formdata.append("mfc_id", this.mfc_id);
      axios
        .post(process.env.VUE_APP_ROOT_API + "get-mf-help-detail", formdata)
        .then((res) => {
          this.missed_call_no_array = res.data.data.missed_call_no_array;
          this.sms_array = res.data.data.sms_array;
          this.whatsapp_no_array = res.data.data.whatsapp_no_array;
          setTimeout(() => {
            this.$modal.hide("update-unit");
            this.account_help_dialog = true;
          }, 500);
        })
        .catch(() => {});
    },

    updatFormCap(id, saving_type){
      let formdata = new FormData();
      formdata.append("form_id", id);
      formdata.append("saving_type", saving_type);
      axios
        .post(process.env.VUE_APP_ROOT_API + "update-user-form-saving-type", formdata)
        .then((res) => {
          // swal.fire({
          //   title: "Saving Type Updated Successfully",
          //   icon: "success",
          // });
        })
        .catch(() => {});
    }
  },
};
</script>
<style scoped>
.inline {
  .select-box {
    max-width: 50px !important;
  }
}
</style>
